// From inc/ directory
import "./inc/read_more.js";
import "./inc/retail_user.js";

// Formerly in vendor.footer.js
import Swiper from 'swiper/bundle';
import { Fancybox } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";
import Rellax from 'rellax';

// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;
window.Swiper = Swiper;

// =============================================================================
// Nav Scroll

// get the sticky element
const stickyEl = document.querySelector('.main-navbar')
const observer = new IntersectionObserver(
    ([e]) => e.target.classList.toggle('top', e.intersectionRatio == 1), {
        threshold: [1]
    }
);

observer.observe(stickyEl)
// =======

document.addEventListener("DOMContentLoaded", () => {
    const siteHeader = document.getElementById("site-header");
    const siteNav = document.getElementById('site-nav');
    const navToggler = document.getElementById("site-navbar-toggler");
    let hasScrolled = false;

    const handleNavbarOnScroll = () => {
        if (window.scrollY > 0) {
            if (!hasScrolled) {
                // User starts scrolling away from the top
                siteHeader.classList.add("transitioning"); // Hide the navbar initially as it scrolls up
                hasScrolled = true;
                setTimeout(() => {
                    // Slide down and fade in the navbar after 2 seconds
                    siteHeader.classList.add("sticky-top", "scrolled");
                    siteHeader.classList.remove("transitioning");
                }, 1500);
            }
        } else {
            // User is at the top of the page, show the navbar
            siteHeader.classList.add("sticky-top");
            siteHeader.classList.remove("transitioning", "scrolled");
            hasScrolled = false;
        }
        setTimeout(() => {
            updatePosition();
            if (siteHeader.classList.contains("top")) {
                siteHeader.classList.remove("scrolled");
            }
        }, 1500);
    };

    const handleNavbarOnLoad = () => {
        if (window.scrollY > 0) {
            // If the page loads scrolled down
            setTimeout(() => {
                siteHeader.classList.add("sticky-top");
            }, 1500);
        } else {
            // If the page loads at the top, ensure the navbar is visible immediately
            siteHeader.classList.add("sticky-top");
        }
    };

    // Check navbar on page load
    handleNavbarOnLoad();

    // Attach scroll event to check user's scroll position
    window.addEventListener("scroll", handleNavbarOnScroll);

    siteNav.addEventListener('hide.bs.offcanvas', event => {
        siteHeader.classList.remove("open");
        navToggler.classList.add("close");
        navToggler.classList.remove("open");
        
    });
    siteNav.addEventListener('show.bs.offcanvas', event => {
        siteHeader.classList.add("open");
        navToggler.classList.add("open");
        navToggler.classList.remove("close");
    });
});

// =============================================================================
// == Actual StickyNav Heights =============

function updatePosition() {
    const mainNav = document.getElementById('site-header');
    const subNav = document.getElementById('subnav');
    const filters = document.getElementById('filters');
    const overlayNav = document.body.classList.contains('overlay-nav');

    let stickyWNav = document.querySelectorAll('.sticky-w-nav');
    let stickyWSubnav = document.querySelectorAll('.sticky-w-subnav');
    let stickyWFilters = document.querySelectorAll('.sticky-w-filters');

    // Set the top position of each target element based on the height of the reference element
    stickyWNav.forEach(function(stickyItem) {
        if (mainNav) {
            let mainNavHeight = mainNav.clientHeight;
            stickyItem.style.top = mainNavHeight + 'px';
        }
    });
    stickyWSubnav.forEach(function(stickyItem) {
        if (mainNav && subNav) {
            let mainNavHeight = mainNav.clientHeight;
            let subNavHeight = subNav.clientHeight;
            stickyItem.style.top = mainNavHeight + subNavHeight + 'px';
        } else if (subNav) {
            let subNavHeight = subNav.clientHeight;
            stickyItem.style.top = mainNavHeight + subNavHeight + 'px';
        }
    });
    stickyWFilters.forEach(function(stickyItem) {
        if (mainNav && subNav && filters) {
            let mainNavHeight = mainNav.clientHeight;
            let subNavHeight = subNav.clientHeight;
            let filtersHeight = filters.clientHeight;
            stickyItem.style.top = mainNavHeight + subNavHeight + filtersHeight + 'px';
        } else if (mainNav && filters) {
            let mainNavHeight = mainNav.clientHeight;
            let filtersHeight = filters.clientHeight;
            stickyItem.style.top = mainNavHeight + filtersHeight + 'px';
        } else if (filters) {
            let filtersHeight = filters.clientHeight;
            stickyItem.style.top = filtersHeight + 'px';
        }
    });

    if (overlayNav) {
        mainNav.style.marginBottom = mainNav.clientHeight * -1 - 1 + 'px';
    } else {
        mainNav.style.marginBottom = 0;
    }

}

window.addEventListener('load', updatePosition);
window.addEventListener('resize', updatePosition);

// =============================================================================
// Trigger Tabs By Hash

var triggerTabList = [].slice.call(document.querySelectorAll(".tab-btn"));

triggerTabList.forEach(function(triggerEl) {
    var tabTrigger = new bootstrap.Tab(triggerEl);
    var hash = '#' + triggerEl.href.split("#")[1];
    var tabBtn = document.querySelector(hash + "-tab");

    triggerEl.addEventListener("click", function(event) {
        event.preventDefault();
        tabBtn.click();
    })
})

// =============================================================================
// == Wrap Last Word In Span =============

function targetLastWord(element) {
    var pieces = element.innerHTML.split(" ");
    var last = pieces.pop();
    var first = pieces.join(" ");
    element.innerHTML = first + '<span class="last-word"> ' + last + '</span>';
}

var lastWords = document.querySelectorAll(".last-word-bold");
lastWords.forEach(x => targetLastWord(x));


// =============================================================================
// == Split String =============

function splitStringByBreak(element) {
    
    // Check if the element has the "fancy-split" class
    var isFancySplit = element.classList.contains("fancy-split");

    // Split the string into words
    var pieces = element.innerHTML.split(/<br\s*\/?>/, 2);
    var isAlreadySplit = element.getElementsByTagName('span');

    // Initialize arrays for the first and second halves
    var isTwoParts = pieces[1];
    var firstHalf = [];
    var secondHalf = [];

    if (isAlreadySplit.length == 0) {
        if (isTwoParts) {
            var firstHalf = [pieces[0]];
            var secondHalf = [pieces[1]];

            // Join the halves back into strings
            var first = firstHalf.join(' ');
            var last = secondHalf.join(' ');

            element.innerHTML = '<span class="first-part"> ' + first + '</span><span class="second-part"> ' + last + '</span>';
        } else {
            var firstHalf = [pieces[0]];
            var first = firstHalf.join(' ');
            if (isFancySplit) {
                element.innerHTML = '<span class="first-part">' + firstHalf + "</span>";
            } else {
                element.innerHTML = '<span class="second-part"> ' + first + '</span>';
            }
        }
    }
}

var splitStrings = document.querySelectorAll(".split-string");
splitStrings.forEach(x => splitStringByBreak(x));

// =============================================================================

document.addEventListener('DOMContentLoaded', () => {
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.35
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const element = entry.target;
            if (entry.isIntersecting) {
                element.classList.add('in-view');
            } 
        });
    }, observerOptions);

    const elementsToObserve = document.querySelectorAll('[data-animation-class]');
    elementsToObserve.forEach(element => {
        const animationClass = element.dataset.animationClass;
        if (animationClass) {
            element.classList.add(animationClass); // Add 'lazy' or whatever, always
        }
        observer.observe(element);
    });
});

// =============================================================================

const createTrianglePattern = () => {
    const bgTris = document.querySelector(".bg-tris");

    // Define the fixed pattern of triangles
    const trianglePattern = [{
            alignment: "tri-right",
            color: "border-light",
            size: 900,
            top: 80,
            speed: -3.75
        },{
            alignment: "tri-left",
            color: "border-light",
            size: 600,
            top: 50,
            speed:-1
        },{
            alignment: "tri-left",
            color: "border-secondary",
            size: 120,
            top: 50,
            speed:1
        },{
            alignment: "tri-right",
            color: "border-primary",
            size: 120,
            top: 100,
            speed:3
        },{
            alignment: "tri-right",
            color: "border-secondary",
            size: 70,
            top:200,
            speed:4.5
        },{
            alignment: "tri-left",
            color: "border-primary",
            size: 70,
            top: 0,
            speed:2.5
        },{
            alignment: "tri-right",
            color: "border-light",
            size: 800,
            top: 400,
            speed:1
        },{
            alignment: "tri-right",
            color: "border-secondary",
            size: 170,
            top: 300,
            speed: 3
        },{
            alignment: "tri-left",
            color: "border-secondary",
            size: 150,
            top: 0,
            speed: 1
        },{
            alignment: "tri-left",
            color: "border-primary",
            size: 100,
            top: 100,
            speed: 2.5
        },{
            alignment: "tri-left",
            color: "border-light",
            size: 450,
            top: 400,
            speed: 1
        },{
            alignment: "tri-right",
            color: "border-light",
            size: 600,
            top: 400,
            speed:0
        },{
            alignment: "tri-left",
            color: "border-secondary",
            size: 170,
            top: 0,
            speed:.25
        }, {
            alignment: "tri-right",
            color: "border-primary",
            size: 120,
            top: 100,
            speed:0
        }, {
            alignment: "tri-right",
            color: "border-secondary",
            size: 70,
            top:200,
            speed:.5
        },
    ];

    // Calculate the page height and the total height of one pattern cycle
    const pageHeight = document.documentElement.scrollHeight;
    const patternHeight = trianglePattern.reduce((sum, tri) => sum + tri.size, 0);

    let currentTop = 0;

    // Repeat the pattern to fill the page
    while (currentTop < pageHeight) {
        trianglePattern.forEach(({
            alignment,
            color,
            size,
            top,
            speed
        }) => {
            if (currentTop >= pageHeight) return; // Stop if the page height is reached

            const triangle = document.createElement("div");
            const triClass = `border-width-` + `${size}`;
            triangle.classList.add(alignment, color, triClass);
            triangle.classList.add("rellax");

            currentTop += top;
            // Set the top position
            if (window.innerWidth > 992) {
                triangle.style.top = `${currentTop / 1.25}px`;
            } else {
                triangle.style.top = `${currentTop / 2.5}px`;
            }

            // Set parallax scroll speed
            const rellaxSpeed = Math.floor(Math.random() * (7 - (-3) + 1)) + -3;
            triangle.setAttribute("data-rellax-speed", speed);

            bgTris.appendChild(triangle);

            // Increment the top position by the triangle's height
            currentTop += size;
        });
    }

    // Remove any extra triangles if the pattern overflows
    const triangles = bgTris.querySelectorAll("div");
    triangles.forEach((triangle) => {
        if (parseInt(triangle.style.top) >= pageHeight) {
            triangle.remove();
        }
    });
};

// Generate the triangles on page load
document.addEventListener("DOMContentLoaded", createTrianglePattern);

// Adjust pattern on resize to fill the new height
window.addEventListener("resize", () => {
    document.querySelector(".bg-tris").innerHTML = ""; // Clear existing triangles
    createTrianglePattern();
});

// =============================================================================

/*
 * FANCYBOX
 *
 * The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
 * the carousel is first initilaized. To avoid triggering 3 image view events on every
 * Fancybox initCarousel action, an imageview event is triggered on the initCarousel
 * event, but "done" events are then ignored for 1 second. After 1 second, image view
 * events will be triggered as typical.
 */

// Tracks fancybox image views.
let fancyboxEventBlock = false

// Abstracted event action handler
const doFancyboxOiEvent = (fancybox) => {
    let oi_event_name = false
    // Identify the proper event name. Use the first occurence from the possibilities
    // below.
    // 1. If a trigger element is available, use the value of data-oi-event-name when
    //    present. This is the most common scenario.
    // 2. If the Fancybox options object has oiEventName attribute, use the value. Event
    //    names are define this way when Fancybox assets are populated by a javascript
    //    array, and not DOM elements are available to place the data attribute.
    if (fancybox.options.$trigger &&
        fancybox.options.$trigger.dataset &&
        fancybox.options.$trigger.dataset.oiEventName) {
        oi_event_name = fancybox.options.$trigger.dataset.oiEventName
    }
    if (oi_event_name) {
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({
                event: oi_event_name
            });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({
                event: oi_event_name
            });
        }
    }
}

// Define Fancybox config
window.FANCYBOX_CONFIG = {
    on: {
        initCarousel: (fancybox) => {
            if (!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true

                // Do Fancybox event
                doFancyboxOiEvent(fancybox)

                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false
                }, 1000)
            }
        },
        done: (fancybox, slide) => {
            if (!fancyboxEventBlock) {
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false
        },
    },
}

// Bind actions to Fancybox events
Fancybox.bind("[data-fancybox]", FANCYBOX_CONFIG)

/* END FANCYBOX */

// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.

window.addEventListener('load', function() {
    oi.utils.wrap_oi_aspect();
    var rellax = new Rellax('.rellax');
}, false);